import request from "@utils/request";

export function getLPPosition(query) {
    return request({
        url: 'lp/position',
        method: 'get',
        params: query
    })
}
